export default __webpack_public_path__ + "static/keyvisual-7911044fc3eaa9d6c56da8ce83fba6ce.mp4";